import { useHistory } from "react-router-dom";
import React, { useDispatch, useEffect, useGlobal } from "reactn";

export const Logout = () => {
	const logout = useDispatch("logout");
	const [user] = useGlobal("user");
	const history = useHistory();
	const onLogout = () => {
		logout().then(() => {
			history.push("/welcome");
		});
	};
	useEffect(() => {
		onLogout();
	}, []);

	return <></>;
};
